<!-- Areas Generales fa -->
<div class="p-fluid p-formgrid grid mt-2" *ngIf="tipo === 'forma'">
    <div class="field col-12 md:col-3" *ngFor="let area of areasGenerales; let i = index">
        <span class="p-float-label p-input-icon-right">
            <i *ngIf="esValidaAreas && area.area" class="pi pi-check" style="font-size:1rem; color:green !important;"></i>
            <i *ngIf="!esValidaAreas" class="pi pi-ban" style="font-size:1rem; color:red !important;"></i>

            <input [(ngModel)]="area.area" type="number" pInputText required [min]="0" [pTooltip]="tooltip" [disabled]="readOnly"
                    (input)="onInput.emit()" (keydown)="onKeydown.emit($event)" (blur)="onBlur.emit({ event: $event, area })"
                    [ngClass]="{'ng-invalid ng-dirty': area.area == null || area.area < 0}" />
            <label class="mb-2" for="area-{{i}}">
                {{area.tipoArea}} <small style="color:black"><b>m²</b></small>
                <small style="color:red"><b>*</b></small>
            </label>
        </span>
        <small *ngIf="(area.area === 0 || area.area === null) && area.idTipoArea === 1" style="color:red">
            <b>Favor ingresar el área de proyecto</b>
        </small>
        <small *ngIf="!esValidaAreas && area.idTipoArea !== 1" style="color:red">
            <b>Área inválida: la suma o el total de las áreas debe ser menor que el área total del proyecto</b>
        </small>
    </div>
</div>
<div class="text-900 font-semibold text-lg -mt-5 mb-5">
    <small style="color:red" class="ng-dirty ng-invalid" *ngIf="!esValidaAreas"><b>Áreas a desarrollar e impermeabilizar inválidas</b></small>
</div>
<!-- Areas Urbanizacion o construccion fa -->
<div class="mt-5" *ngIf="tipo === 'forma'">
    <div class="text-900 font-semibold text-xl">
        {{ titulo }}
        <span *ngIf="tipoConstruccion() !== null && titulo.includes('estimadas')">
            de {{ tipoConstruccion() ? 'construcción' : 'urbanización' }}
        </span>
    </div>

    <div class="p-fluid p-formgrid grid mt-2">
        <div class="field col-12 md:col-4" *ngFor="let area of areasForm; let i = index">
        <span class="p-float-label p-input-icon-right">

            <i *ngIf="area.area !== null && area.area !== 0 && !isValidarAreas(tipoConstruccion())"
            class="pi pi-check" style="font-size:1rem; color:green !important;"></i>

            <i *ngIf="isValidarAreas(tipoConstruccion()) && area.area !== 0"
            class="pi pi-ban" style="font-size:1rem; color:red !important;"></i>

            <input [(ngModel)]="area.area"
                type="number"
                required
                pInputText
                [min]="0"
                pTooltip="La suma de las áreas no debe ser mayor al área total"
                [disabled]="readOnly"
                (keydown)="onKeydown.emit($event)"
                (blur)="onBlur.emit({ event: $event, area })"
                [ngClass]="{
                    'ng-invalid ng-dirty':
                    area.idTipoArea === 2
                        ? !tramiteCompleto && (!area.area || area.area === 0) && tipoConstruccion()
                        : (!area.area || area.area === 0) && !tipoConstruccion()
                }"/>

            <label class="mb-2" for="area-{{ i }}">
            {{ area.tipoArea }}
            <small [style]="{ color: (area.area == null || area.area < 0) ? 'red' : 'black' }"><b> m²</b></small>
            <small style="color:red"><b> *</b></small>
            <span *ngIf="mostrarPorcentaje">{{ calcularPorcentajeTotal(area.area || 0) }}</span>
            </label>
        </span>
        </div>
    </div>

    <div *ngIf="validarSuma" class="text-900 font-semibold text-lg -mt-5 mb-5">
        <small style="color:red" class="ng-dirty ng-invalid">
        <b>La suma de las áreas no debe ser mayor al área total</b>
        </small>
    </div>
</div>
<!-- Area Construccion fb -->
<div class="p-fluid p-formgrid grid mt-2" *ngIf="tipo === 'formb'">
    <div class="field col-12 md:col-3">
        <span class="p-float-label">
            <!-- TODO Validar la suma del area activa, si es construccion no sea mayor al area total -->
            <input [value]="areaActiva()"
                id="areaTotal"
                type="number"
                required
                pInputText
                pattern="(0(\\.0+)?|[1-9][0-9]*(\\.[0-9]+)?)"
                [min]="0"
                [disabled]="readOnly"
                (input)="setAreaActiva($any($event.target).valueAsNumber)"
                (blur)="onBlurFb.emit(areaActiva() ?? undefined)"
                [ngClass]="{ 'ng-invalid ng-dirty': !tramiteCompleto && (areaActiva() == null || areaActiva() === 0) }" />

            <label for="areaTotal" class="mb-2">
                {{ tipoConstruccion() ? 'Área Construcción' : 'Área Proyecto' }}
                <small style="color:black"><b> m²</b></small>
                <small style="color:red"><b> *</b></small>
            </label>
        </span>
        <small *ngIf="isValidArea" style="color:red">
        <b>Area Invalida, el area de construcción no debe ser mayor al area total.</b>
        </small>

        <small *ngIf="areaActiva() === 0 || areaActiva() === null" style="color:red">
        <b>Favor ingresar el área de proyecto</b>
        </small>
    </div>
</div>
<!-- Area formulario C -->
 <div class="p-fluid p-formgrid grid mt-2" *ngIf="tipo === 'formc'">
     <div class="field col-12 md:col-3">
         <span class="p-float-label">
            <!-- TODO Validar la suma del area activa, si es construccion no sea mayor al area total -->
             <input [ngModel]="areaSignal()" [value]="areaSignal()" type="number" pInputText required pattern="(0(\\.0+)?|[1-9][0-9]*(\\.[0-9]+)?)"
                [min]="0"  [disabled]="readOnly" (blur)="onBlurFc.emit({ event: $event, area: areaSignal()! })" (keydown)="onKeydown.emit($event)" (input)="onInputChange($event)"
                [ngClass]="{'ng-invalid ng-dirty': areaSignal() === null || areaSignal() === 0}"/>
                <label class="mb-2">Área de proyecto<small style="color: black"><b> m²</b></small>
                    <small style="color: red"><b> *</b></small>
                </label>
         </span>
         <small *ngIf="areaSignal() === 0 || areaSignal() === null" style="color: red">
             <b>Favor ingresar el área de proyecto</b>
         </small>
     </div>
 </div>